import { Reveal } from "../components/Reveal";
import { SectionLabel } from "../components/SectionLabel";

const STEPS = [
  { n: "01", name: "DEFINE", desc: "We lock the goal, space, timeline and non-negotiables." },
  { n: "02", name: "DESIGN", desc: "Creative, materials and engineering become one build plan." },
  { n: "03", name: "BUILD", desc: "Print and fabrication happen under one accountable team." },
  { n: "04", name: "DEPLOY", desc: "We deliver, install and make the physical experience land." },
];

export default function Process() {
  return (
    <section id="process" data-testid="process-section" className="scroll-mt-20 bg-ink">
      <div className="mx-auto max-w-7xl px-4 py-24 sm:px-6 lg:px-8 lg:py-36">
        <Reveal>
          <SectionLabel index="CH.07">Process</SectionLabel>
        </Reveal>
        <div className="mt-10 grid grid-cols-1 gap-10 lg:grid-cols-12 lg:items-end">
          <Reveal className="lg:col-span-7">
            <h2 className="font-display text-3xl font-extrabold uppercase leading-[1.12] tracking-tight text-paper sm:text-5xl sm:leading-[1.08] lg:text-6xl">
              Built like
              <br />
              the render<span className="text-acid">.</span>
            </h2>
          </Reveal>
          <Reveal delay={0.15} className="lg:col-span-5">
            <p className="text-base leading-relaxed text-fog sm:text-lg">
              You get one team from design through deployment. Fewer handoffs. Faster decisions.
              More control over the details that make the experience feel expensive.
            </p>
          </Reveal>
        </div>

        <div className="mt-14 grid grid-cols-1 gap-px bg-white/10 sm:grid-cols-2 lg:grid-cols-4">
          {STEPS.map((s, i) => (
            <Reveal key={s.n} delay={0.1 * i} className="h-full">
              <div
                data-testid={`process-step-${s.n}`}
                className="group flex h-full flex-col bg-ink p-8 transition-colors duration-500 hover:bg-panel lg:p-10"
              >
                <span className="font-display text-6xl font-extrabold leading-none text-stroke-acid transition-colors duration-500 group-hover:text-acid lg:text-7xl">
                  {s.n}
                </span>
                <h3 className="mt-8 font-display text-xl font-bold uppercase tracking-tight text-paper">
                  {s.name}
                </h3>
                <p className="mt-3 text-sm leading-relaxed text-fog">{s.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
